import { meta } from '@/helpers/constants/router';
import { SHOPIFY_PRODUCT_MENU_KEY, SHOPIFY_CART_MENU_KEY, SHOPIFY_ORDER_MENU_KEY, SHOPIFY_MARKETING_MENU_KEY, CUSTOMER_SEGMENT, STORE_SETUP_MENU_KEY, } from '@/helpers/constants/app';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Wrapper = () => import('@/views/Wrapper.vue');
const ComingSoon = () => import('@/views/v2/ComingSoon.vue');
const Shopify = () => import('@/views/v2/Shopify.vue');
const Referrals = () => import('@/views/v2/Referrals.vue');
const ReferralList = () => import('@/components/v2/ReferralLinks.vue');
const SmartRetailLinks = () => import('@/components/v2/SmartRetailLinks.vue');
const cartSettingsRouteName = 'shopify-cart-settings';
const storeSetupRouteName = 'ecommerce-store-setup';
export default [
    {
        path: 'shopify',
        component: Wrapper,
        children: [
            {
                path: 'products',
                component: Wrapper,
                redirect: SHOPIFY_PRODUCT_MENU_KEY,
                meta: { ...meta, title: 'Products' },
                children: [
                    {
                        path: 'shopify-categories',
                        name: 'shopify-categories',
                        component: Shopify,
                        meta: {
                            title: 'Categories',
                            parentMenu: SHOPIFY_PRODUCT_MENU_KEY,
                        },
                    },
                    {
                        path: '/',
                        name: SHOPIFY_PRODUCT_MENU_KEY,
                        component: Shopify,
                        meta: {
                            title: 'All Products',
                            parentMenu: SHOPIFY_PRODUCT_MENU_KEY,
                        },
                    },
                ],
            },
            {
                path: 'overview',
                component: Wrapper,
                meta: { ...meta, title: 'Overview' },
                children: [
                    {
                        path: '/',
                        name: 'shopify-overview',
                        component: () => import('@/views/v3/Overview.vue'),
                        meta: { title: 'Overview' },
                        children: [
                            {
                                path: 'latest-sold-products',
                                name: 'shopify-sold-products',
                                component: () => import('@/components/v2/ecommerce/LatestSoldProductsIndex.vue'),
                                meta: { title: `Today's Latest Sold Products` },
                            },
                            {
                                path: 'sales-amount',
                                name: 'shopify-sales-amount',
                                component: () => import('@/components/v2/ecommerce/SalesAmountIndex.vue'),
                                meta: { title: `Today's Sales Amount` },
                            },
                            {
                                path: 'latest-customers',
                                name: 'shopify-latest-customers',
                                component: () => import('@/components/v2/ecommerce/LatestCustomersIndex.vue'),
                                meta: { title: `Today's Latest Customers` },
                            },
                        ],
                    },
                    {
                        path: 'performance',
                        component: Wrapper,
                        meta: {
                            title: 'In-App Store Performance',
                            redirect: 'shopify-performance',
                        },
                        children: [
                            {
                                path: '/',
                                name: 'shopify-performance',
                                component: () => import('@/views/v2/ecommerce/Performance.vue'),
                                meta: {
                                    title: 'In-App Store Performance',
                                },
                            },
                            {
                                path: 'popular-producs',
                                name: 'shopify-popular-products',
                                component: () => import('@/views/v2/ecommerce/PopularProductList.vue'),
                                meta: {
                                    title: 'Most Popular Products',
                                    parentMenu: 'shopify-performance',
                                },
                            },
                            {
                                path: 'most-sold-producs',
                                name: 'shopify-profitable-products',
                                component: () => import('@/views/v2/ecommerce/ProfitableProductList.vue'),
                                meta: {
                                    title: 'Most Sold Products',
                                    parentMenu: 'shopify-performance',
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'store-setup',
                component: Wrapper,
                redirect: storeSetupRouteName,
                meta: { ...meta, title: 'Store Setup' },
                children: [
                    {
                        path: 'cart-settings',
                        name: cartSettingsRouteName,
                        component: Shopify,
                        meta: {
                            title: 'Checkout Settings',
                            parentMenu: STORE_SETUP_MENU_KEY,
                        },
                    },
                    {
                        path: 'delivery-areas',
                        component: Wrapper,
                        redirect: 'shopify-delivery-areas',
                        meta: { ...meta, title: 'Delivery Areas' },
                        children: [
                            {
                                path: '/',
                                name: 'shopify-delivery-areas',
                                component: Shopify,
                                meta: { title: 'Delivery Areas', parentMenu: STORE_SETUP_MENU_KEY },
                            },
                        ],
                    },
                    {
                        path: 'shipping-methods',
                        component: Wrapper,
                        redirect: 'shopify-shipping',
                        meta: { ...meta, title: 'Shipping' },
                        children: [
                            {
                                path: '/',
                                name: 'shopify-shipping',
                                component: () => import('@/views/v2/apps/ShippingMethods.vue'),
                                meta: { title: 'Shipping', subtitle: 'Manage your shipping methods', parentMenu: STORE_SETUP_MENU_KEY },
                            },
                            {
                                path: 'create',
                                name: 'shopify-shipping-create',
                                component: () => import('@/views/v2/apps/ShippingMethodsCreate.vue'),
                                meta: {
                                    title: 'Create Shipping Method',
                                    subtitle: 'Configure your chosen shipping method here.',
                                    parentMenu: STORE_SETUP_MENU_KEY
                                },
                            },
                            {
                                path: ':uuid',
                                component: Wrapper,
                                meta,
                                children: [
                                    {
                                        path: 'edit',
                                        name: 'shopify-shipping-edit',
                                        props: true,
                                        component: () => import('@/views/v2/apps/ShippingMethodsEdit.vue'),
                                        meta: { title: 'Edit Shipping Method',
                                            parentMenu: STORE_SETUP_MENU_KEY },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'payment',
                        component: Wrapper,
                        redirect: 'shopify-payment',
                        meta: { ...meta, title: 'Payment' },
                        children: [
                            {
                                path: '/',
                                name: 'shopify-payment',
                                component: () => import('@/views/v2/Payments.vue'),
                                meta: {
                                    title: 'Payment',
                                    subtitle: 'Manage all your chosen payment methods here.',
                                },
                            },
                            {
                                path: 'merchant',
                                name: 'shopify-merchant-registration',
                                component: () => import('@/views/v2/MerchantPaymentRegistration.vue'),
                                meta: {
                                    title: 'Merchant Registration',
                                    subtitle: '',
                                    parentMenu: STORE_SETUP_MENU_KEY
                                },
                            },
                            {
                                path: 'kyc-verification',
                                name: 'shopify-kyc-verification',
                                component: () => import('@/views/v2/XenditKycVerification.vue'),
                                meta: {
                                    title: 'Xendit Account KYC Verification',
                                    parentMenu: STORE_SETUP_MENU_KEY
                                },
                            },
                        ],
                    },
                    {
                        path: 'notifications',
                        name: 'shopify-notifications',
                        component: () => import('@/views/v2/NotificationsManager.vue'),
                        meta: {
                            ...meta, title: 'Notification Manager',
                            subtitle: 'Create and manage your notifications here.',
                        },
                        redirect: { name: 'shopify-notifications-manager-email' },
                        children: [
                            {
                                path: 'fb-messenger',
                                name: 'shopify-notifications-manager-fb-messenger',
                                meta: {
                                    title: 'Notification Manager',
                                    subtitle: 'Create and manage your notifications here.',
                                    parentMenu: 'shopify-notifications'
                                },
                                component: () => import('@/views/v2/NotificationsFbMessenger.vue'),
                            },
                            {
                                path: 'email',
                                name: 'shopify-notifications-manager-email',
                                meta: {
                                    title: 'Notification Manager',
                                    subtitle: 'Create and manage your notifications here.',
                                    parentMenu: 'shopify-notifications'
                                },
                                component: () => import('@/views/v2/NotificationsEmail.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'promos',
                component: Wrapper,
                redirect: 'shopify-promos',
                meta: { ...meta, title: 'Voucher' },
                children: [
                    {
                        path: '/',
                        name: 'shopify-promos',
                        component: () => import('@/views/v2/apps/PromoCodes.vue'),
                        meta: {
                            title: 'Discounts',
                            parentMenu: SHOPIFY_CART_MENU_KEY,
                        },
                    },
                    {
                        path: 'create',
                        name: 'shopify-promos-create',
                        component: () => import('@/views/v2/apps/PromoCodeCreate.vue'),
                        meta: {
                            title: 'Create Promo Code',
                            subtitle: 'Customize your promo codes here.',
                            parentMenu: SHOPIFY_CART_MENU_KEY
                        },
                    },
                    {
                        path: ':uuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'edit',
                                name: 'shopify-promos-edit',
                                props: true,
                                component: () => import('@/views/v2/apps/PromoCodeEdit.vue'),
                                meta: { title: 'Edit Promo Code', parentMenu: SHOPIFY_CART_MENU_KEY },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'cart-promos',
                component: Wrapper,
                redirect: 'shopify-cart-promos',
                meta: { title: 'Cart Promos' },
                children: [
                    {
                        path: '/',
                        name: 'shopify-cart-promos',
                        component: Shopify,
                        meta: {
                            title: 'Cart Promos',
                            parentMenu: SHOPIFY_CART_MENU_KEY,
                        },
                    },
                ],
            },
            {
                path: 'add-ons',
                component: Wrapper,
                redirect: 'shopify-add-ons',
                meta: { ...meta, title: 'Add - Ons / Upsell' },
                children: [
                    {
                        path: '/',
                        name: 'shopify-add-ons',
                        meta: { title: 'Add - Ons / Upsell', parentMenu: SHOPIFY_PRODUCT_MENU_KEY },
                        component: Shopify,
                    },
                ],
            },
            {
                path: 'orders',
                component: Wrapper,
                redirect: 'shopify-orders-by-status',
                meta: { ...meta, title: 'Orders' },
                children: [
                    {
                        path: 'history',
                        name: 'shopify-order-history',
                        meta: { title: 'Order History', subtitle: 'View and track all your orders here.', parentMenu: SHOPIFY_ORDER_MENU_KEY },
                        props: true,
                        component: () => import('@/views/v2/ecommerce/OrderHistory.vue'),
                    },
                    {
                        path: ':status/:filter?',
                        component: () => import('@/views/v2/ecommerce/Orders.vue'),
                        children: [
                            {
                                path: '/',
                                name: 'shopify-orders-by-status',
                                meta: {
                                    title: 'Order Tracker',
                                    subtitle: 'View all orders here.',
                                    parentMenu: SHOPIFY_ORDER_MENU_KEY
                                },
                                props: true,
                                component: () => import('@/views/v2/ecommerce/OrdersByStatus.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'customers',
                component: Wrapper,
                meta: { ...meta, title: CUSTOMER_SEGMENT },
                children: [
                    {
                        path: '/',
                        name: 'shopify-customers',
                        meta: { title: CUSTOMER_SEGMENT, parentMenu: SHOPIFY_MARKETING_MENU_KEY },
                        component: ComingSoon,
                    },
                ],
            },
            {
                path: 'referrals',
                component: Wrapper,
                meta: { ...meta, title: 'Referrals' },
                children: [
                    {
                        path: '',
                        component: Referrals,
                        meta: { ...meta, title: 'Referrals' },
                        children: [
                            {
                                path: '/',
                                name: 'shopify-referral',
                                meta: {
                                    title: 'Referrals',
                                    redirect: 'shopify-referral',
                                    parentMenu: SHOPIFY_MARKETING_MENU_KEY,
                                },
                                component: ReferralList,
                            },
                            {
                                path: 'smart-retail-links',
                                component: Wrapper,
                                meta: { ...meta, title: 'Referrals' },
                                children: [
                                    {
                                        path: '/',
                                        name: 'shopify-smart-retail',
                                        meta: {
                                            title: 'Smart Retail Links',
                                            redirect: 'shopify-smart-retail',
                                            parentMenu: SHOPIFY_MARKETING_MENU_KEY,
                                        },
                                        component: SmartRetailLinks,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: ':referralLinkUuid',
                        component: Wrapper,
                        meta,
                        children: [
                            {
                                path: 'details',
                                name: 'shopify-referral-details',
                                meta: { title: 'Referral Details', parentMenu: SHOPIFY_MARKETING_MENU_KEY },
                                component: () => import('@/views/v2/ReferralDetails.vue'),
                                props: true,
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
